import Product from '../Product';

function CubicSpaceAvailable({
  result,
  convRatio,
  drawingBaseDimensions,
  unitSystem,
}) {
  const prodT =
    (drawingBaseDimensions.nbr_windings -
      1 +
      Math.acos(
        result.column_centre_to_inside_windings /
          result.column_centre_to_inside_outer_guide
      ) /
        (2 * Math.PI)) /
    drawingBaseDimensions.nbr_windings;

  const verticalClearance = result.vertical_clearance_without_product;

  const productToShow = {
    length: result.product_max_length,
    width: result.horizontal_clearance_without_product,
    height: verticalClearance,
  };

  return (
    <Product
      result={result}
      convRatio={convRatio}
      product={productToShow}
      showProduct={0}
      t={prodT}
      color="CubicSpaceAvailable"
      drawingBaseDimensions={drawingBaseDimensions}
      unitSystem={unitSystem}
    />
  );
}

export default CubicSpaceAvailable;
